import React from 'react';

import AtlaskitPopup from '@qality/common-components/src/atoms/atlaskit/Popup';

import { PopupComponentStyled, PopupHeaderStyled } from './Popup.styled';

export const Popup = ({
  children,
  header,
  trigger,
  isOpen,
  onClose,
  placement,
  onMouseLeave,
}: any) => {
  return (
    <AtlaskitPopup
      isOpen={isOpen}
      onClose={onClose}
      placement={placement}
      content={() => (
        <PopupComponentStyled onMouseLeave={onMouseLeave}>
          {header && (
            <PopupHeaderStyled size='small'>{header}</PopupHeaderStyled>
          )}
          {children}
        </PopupComponentStyled>
      )}
      trigger={trigger}
    />
  );
};
